
<b-container v-if="get_next_to_bind" id="bind-batch" fluid>
    <b-row>
        <b-col cols="4">
            <div style="text-align: center">
                <b-button variant="danger" v-on:click="checkIncoherencesAndBind(true)" :disabled="binding">
                    Valider !
                </b-button>
                <b-button variant="info" v-on:click="doRotation(true)" :disabled="binding || is_one_document"
                    title="Presser + pour effectuer une rotation de +90°">
                    Rotation 90° (+)
                </b-button>
                <b-button variant="info" v-on:click="doRotation(false)" :disabled="binding || is_one_document"
                    title="Presser - pour effectuer une rotation de -90°">
                    Rotation -90° (-)
                </b-button>
                <b-button variant="info" v-on:click="doZoom(true)" :disabled="binding || is_one_document"
                    title="Presser p pour agrandir l'image, 'echap' pour annuler">
                    Zoom plus (p)
                </b-button>
                <b-button variant="info" v-on:click="doZoom(false)" :disabled="binding || is_one_document"
                    title="Presser m pour diminuer l'image, 'echap' pour annuler">
                    Zoom moins (m)
                </b-button>
                <b-button variant="info" v-on:click="unbind_all = true" title="Détacher tout" :disabled="is_one_document">
                    Détacher tout
                </b-button>
                <b-button variant="danger" v-on:click="checkIncoherencesAndBind(false)" :disabled="binding">
                    Valider et STOP WORKING!
                </b-button>
                <p v-if="bind_waiting" style="color: green">
                    {{ bind_waiting }}
                </p>
                <p v-if="bind_error" style="color: red">
                    {{ bind_error }}
                </p>
                <p v-if="bind_error" class="btn btn-warning" v-on:click="keepOnBinding()">
                    Passer à la suite sans attacher
                </p>
            </div>
            <div v-if="is_one_document" class="is_one_document">
                IS ONE DOCUMENT, bind tout en un seul document !!!
            </div>
            <div class="incoherence" v-for="(incoherence) in multipleReferencesOnSameBoundDocument">
                ⚠️ ERREUR : numéros de factures différents sur un groupe de pages ({{ incoherence.join(',') }})
            </div>
            <div class="incoherence" v-for="(incoherence) in sameReferenceOnSeveralBoundDocuments">
                ⚠️ ERREUR : numéros de factures identiques sur 2 groupes de pages ({{ incoherence }})
            </div>
            <preview-toolbar @tile="change_display" :documentIds="documents"
                :documentWithReferences="documents_with_references" :documentInFullDocs="documents_in_full_doc"
                :unbind_all="unbind_all" :paths="paths" @unbound="unbounded_documents" ref="selector"
                :key="JSON.stringify(documents)"
                @updateReferenceIncoherences="update_references_incoherences" :isOneDocument="is_one_document" ></preview-toolbar>
        </b-col>
        <b-col cols="8">
            <div style="text-align: center">
                <p>.</p>
                <p>.</p>
            </div>
            <img id="main-image" ref="main-image" type="image/svg+xml" class="img-fluid" v-if="displayedHover"
                :src="get_url_for_id" v-on:load="orientation_start()" />
        </b-col>
    </b-row>
</b-container>
<b-container v-else style="margin-top: 5rem;">
    <h2>STOP WORKING ! vous pouvez fermer cette fenêtre.</h2>
</b-container>
